import { api, ApiError } from "./api.js";
import { playerStore } from "./playerStore.js";

/** Reuse an existing destination, including after an invitation partially failed. */
export async function inviteDestination(kind: "duo" | "gold") {
  const activity = await api.activity();
  playerStore.set((state) => ({ ...state, activity }));
  if (kind === "duo" && activity.type === "party") return { code: activity.code };
  if (kind === "gold" && activity.type === "lobby") return { code: activity.code };
  if (activity.type !== "idle") throw new ApiError(409, activity.type === "match" ? "already_seated" : "already_in_lobby");
  const destination = kind === "duo" ? await api.createParty()
    : await api.createLobby({ mode: "gold", rulesetId: "standard", coinTier: "practice" });
  const next = await api.activity();
  playerStore.set((state) => ({ ...state, activity: next }));
  return destination;
}

/** Refresh human-facing counts from the server, independently of invitation actions. */
export async function refreshSocialSummary() {
  const boot = await api.bootstrap();
  playerStore.set((state) => ({ ...state, unread: boot.unread, counts: boot.social,
    invitesById: Object.fromEntries(boot.invites.map((invite) => [invite.id, invite])),
  }));
}
